import React from "react"
import { Form, Image } from "react-bootstrap"
import QuillTextEditor from "../../../../components/QuillTextEditor"

const ExperienceSectionForm = ({
  fields,
  onInputChange,
  upload,
  showAlert,
  isUploading,
  validationErrors,
  setValidationErrors,
  section = "experienceSection"
}) => {
  const handleFileUpload = async (key, file) => {
    try {
      const res = await upload(file)
      if (res?.url) onInputChange(section, key, res.url)
    } catch (err) {
      showAlert("File upload failed.", "danger")
    }
  }

  const handleInputChange = (key, value) => {
    onInputChange(section, key, value)
    if (validationErrors[`${section}.${key}`]) {
      setValidationErrors((prev) => ({
        ...prev,
        [`${section}.${key}`]: undefined,
      }))
    }
  }

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>
          Heading {fields.isVisible && <span className="text-danger">*</span>}
        </Form.Label>
        <Form.Control
          type="text"
          placeholder={`Heading ${fields.isVisible ? "*" : ""}`}
          value={fields.heading || ""}
          onChange={(e) => handleInputChange("heading", e.target.value)}
          isInvalid={!!validationErrors[`${section}.heading`]}
        />
        {validationErrors[`${section}.heading`] && (
          <Form.Control.Feedback type="invalid">
            {validationErrors[`${section}.heading`]}
          </Form.Control.Feedback>
        )}
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>
          Description {fields.isVisible && <span className="text-danger">*</span>}
        </Form.Label>
        {/* <Form.Control
          as="textarea"
          rows={3}
          placeholder={`Description ${fields.isVisible ? "*" : ""}`}
          value={fields.description || ""}
          onChange={(e) => handleInputChange("description", e.target.value)}
          isInvalid={!!validationErrors[`${section}.description`]}
        /> */}
        <QuillTextEditor 
          value={fields.description || ""}
          onChange={(value) => handleInputChange("description", value)}
        />
        {validationErrors[`${section}.description`] && (
          <Form.Control.Feedback type="invalid">
            {validationErrors[`${section}.description`]}
          </Form.Control.Feedback>
        )}
      </Form.Group>

      <div className="mb-3">
        <Form.Label>Image</Form.Label>
        <Form.Control
          type="file"
          accept="image/*"
          onChange={(e) =>
            e.target.files?.[0] &&
            handleFileUpload("image", e.target.files[0])
          }
        />
        {isUploading && (
          <div className="text-muted small mt-1">Uploading...</div>
        )}
        {fields.image && (
          <div className="mt-2">
            <Image
              src={fields.image}
              alt="Experience Preview"
              thumbnail
              style={{ maxWidth: "200px" }}
            />
          </div>
        )}
      </div>
    </>
  )
}

export default ExperienceSectionForm
